import styled from 'styled-components';
import { Button } from './button-base';
import { buttonStyleGenerator } from './button-style-generator';

export const SecondaryButton = styled(Button)`
    ${buttonStyleGenerator('secondary')};
`;
